// extracted by mini-css-extract-plugin
module.exports = {"container":"-alert-frequency-container-_pIGK4-","title":"-alert-frequency-title-2pHiXk-","option":"-alert-frequency-option-3HMXSg-"};